window.onload = function () {
    var i;
    var links = document.querySelectorAll('a');
    for (i = 0; i < links.length; i++) {
        var link = links[i];
        if (link.href.indexOf('#') >= 0) {
            link.href = location.pathname + '#' + link.href.split('#')[1];
        }
    }
};

function toggleNavbar() {
    var toggle = document.getElementById('toggleNavbar');
    var navbar = document.getElementById('navbar-main');
    if (toggle.classList.contains('active')) {
        toggle.classList.remove('active');
        navbar.classList.remove('in');
    } else {
        toggle.classList.add('active');
        navbar.classList.add('in');
    }
}
window.toggleNavbar = toggleNavbar;

function parallax() {
    var height = window.innerHeight;
    var elements = document.querySelectorAll('.bg-parallax');
    for (var i = 0; i < elements.length; ++i) {
        var el = elements[i];
        var imgT = el.getBoundingClientRect().top;
        var imgH = imgT + el.getBoundingClientRect().height;
        var ff = height - imgT;
        var ls = height - imgT + imgH;
        var percent = (ff / ls) * 100;
        if (percent < 0) percent = 0;
        if (percent > 100) percent = 100;
        el.style.backgroundPositionY = percent + '%';
        el.style.backgroundSize = 'cover';
    }
}

window.addEventListener('scroll', parallax);
parallax();
setTimeout(parallax, 500);
setTimeout(parallax, 1000);